// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2U5rZ","footer":"ModalInfo_footer__SI5oW"};